import React, { useEffect, useState } from "react";
import { getSiteContent } from "../services/api";
import Seo from "../components/Seo";
import { loadSection } from "../services/contentSource";
import careerFallback from "../data/career.json";

const Career = () => {
  const [careerData, setCareerData] = useState<any>(null);

  useEffect(() => {
    loadSection("career", careerFallback as any).then(({ data: main }) => setCareerData(main));
  }, []);

  if (!careerData) return null;

  return (
    <>
      <Seo
        title="Careers"
        description="Open roles at MindSyncX Labs for engineers who want to own systems end to end."
        path="/career"
      />
      <link rel="stylesheet" href="/assets/css/master-career.css" />
      <main>
        {/* hero area start  */}
        <section className="hero-area">
          <div className="container">
            <div className="hero-area-inner">
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h1 className="section-title large has_fade_anim">
                      {careerData.hero.titleLine1} <br />
                      <img
                        className="shape-1"
                        src={careerData.hero.titleImage}
                        alt="image" loading="lazy" decoding="async" />
                      {careerData.hero.titleLine2}
                    </h1>
                  </div>
                </div>
                <div className="text-box">
                  <div className="subtitle-wrapper">
                    <span
                      className="section-subtitle has-right-line has_fade_anim"
                      data-fade-from="left"
                      data-delay="0.30"
                    >
                      {careerData.hero.subtitle}
                    </span>
                  </div>
                  <div className="text-wrapper">
                    <p
                      className="text has_fade_anim"
                      data-fade-from="left"
                      data-delay="0.45"
                    >
                      {careerData.hero.text}
                    </p>
                  </div>
                </div>
                <div className="thumb overflow-hidden">
                  <img
                    src={careerData.hero.image}
                    data-speed="0.8"
                    alt="image" loading="lazy" decoding="async" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* hero area end  */}

        {/* community area start  */}
        <section className="community-area">
          <div className="container">
            <div className="community-area-inner section-spacing">
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_fade_anim">
                      {careerData.community.title}
                    </h2>
                  </div>
                </div>
                <div className="text-wrapper">
                  <p className="text has_fade_anim">
                    {careerData.community.text}
                  </p>
                </div>
                <div className="gallery-wrapper-box has_fade_anim">
                  <div className="gallery-wrapper">
                    {careerData.community.gallery.map((img: string, index: number) => (
                      <div key={index} className="thumb">
                        <img src={img} alt={`gallery-${index}`} loading="lazy" decoding="async" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* community area end  */}

        {/* roles area start  */}
        <section className="roles-area">
          <div className="container">
            <div className="roles-area-inner section-spacing">
              <div className="section-header">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_fade_anim">
                      {careerData.roles.title}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="roles-wrapper-box">
                <div className="roles-wrapper">
                  {careerData.roles.items.map((item: any, index: number) => (
                    <div className="has_fade_anim" key={index}>
                      <a href={item.link}>
                        <div className="role-item">
                          <span className="serial">{item.serial}</span>
                          <h3 className="title">{item.title}</h3>
                          <p className="positions">{item.positions}</p>
                          <span className="icon">
                            <img src={item.icon} alt="icon" loading="lazy" decoding="async" />
                          </span>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* roles area end  */}

        {/* process area start  */}
        <section className="process-area">
          <div className="container">
            <div className="process-area-inner section-spacing">
              <div className="section-header">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_fade_anim">
                      {careerData.process.title}
                    </h2>
                  </div>
                </div>
                <div className="text-wrapper">
                  <p className="text has_fade_anim">
                    {careerData.process.text}
                  </p>
                </div>
              </div>
              <div className="process-wrapper-box">
                <div className="process-wrapper">
                  {careerData.process.steps.map((step: any, index: number) => (
                    <div
                      className="process-box has_fade_anim"
                      data-delay={step.delay}
                      key={index}
                    >
                      <div className="thumb">
                        <img
                          className="show-light"
                          src={step.icon.light}
                          alt="process icon" loading="lazy" decoding="async" />
                        <img
                          className="show-dark"
                          src={step.icon.dark}
                          alt="process icon" loading="lazy" decoding="async" />
                      </div>
                      <div className="content">
                        <h3 className="title">{step.title}</h3>
                        <p className="text">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* process area end  */}
      </main>
    </>
  );
};

export default Career;
